import { AREA_TAB_LABEL } from '../data/areaLabels';
// What a documented decision is about: the finding ("fund") it was written
// on, by the same key Arbejdskø groups objects under (findingKey on the note).
// Keep in step with the groups in hooks/useFindingGroups.js.
const FINDING_TITLES = {
  'app-big': 'Apps med stor adgang',
  'app-usage-unknown': 'Apps uden brugsdata',
  'enheder-afviger': 'Enheder, der afviger',
  'sp-review': 'Workspaces at gennemgå',
  'exchange-shared-review': 'Delte postkasser at gennemgå',
  'id-never': 'Konti, der aldrig har logget ind',
  'enheder-agent': 'Ingen rapporteret sikkerhedsstatus',
  'id-mfa': 'Ingen MFA eller totrinsgodkendelse',
  'id-inactive': 'Inaktive konti',
  'id-guests': 'Gæstebrugere',
  'id-risky': 'Brugere markeret som risiko',
  'id-old-password': 'Gammel adgangskode uden MFA',
  'id-weak-mfa': 'Kun svag MFA-metode',
  'id-disabled-licensed': 'Deaktiverede konti med licens',
  'exchange-forward': 'Postkasser med ekstern videresendelse',
  'exchange-orphaned-access': 'Postkasser med adgang tildelt slettede brugere',
  'exchange-domain-missing': 'Domæner uden SPF eller DMARC',
  'exchange-domain-weak': 'DMARC uden håndhævelse',
  'exchange-shared-signin': 'Delte postkasser med login slået til',
  'exchange-near-full': 'Postkasser tæt på fuld',
  'app-priv': 'Apps med vidtgående permissions',
  'app-unused': 'Apps uden registreret brug',
  'app-secret-expired': 'Udløbede hemmeligheder',
  'app-secret-expiring': 'Hemmeligheder der udløber snart',
  'app-write-all': 'Apps med skriveadgang til hele tenanten',
  'app-unverified': 'Apps uden verificeret udgiver',
  'roller-global': 'Permanent Global Administrator',
  'roller-other': 'Andre rolletildelinger',
  'roller-no-mfa': 'Administratorer uden MFA',
  'roller-guest-admin': 'Gæster med administratorrolle',
  'roller-inactive-admin': 'Inaktive administratorer',
  'roller-app-admin': 'Apps med administratorrolle',
  'ca-report': 'Kun rapportering',
  'ca-disabled': 'Deaktiverede loginregler',
  'sik-high': 'Høj alvor',
  'sik-other': 'Øvrige åbne',
  'sik-risky-signin': 'Mistænkelige login',
  'sik-failed-signins': 'Mange mislykkede login',
  'sik-legacy-auth': 'Login med forældet godkendelse',
  'sik-stale-open': 'Åbne sager uden opfølgning',
  'sp-inactive': 'Inaktive sites',
  'sp-no-owner': 'Intet registreret ejerskab',
  'sp-guests': 'Workspaces med gæster',
  'sp-guests-stale': 'Gæster i inaktive workspaces',
  'sp-public': 'Åbne workspaces',
  'sp-quota': 'Sites tæt på kvote',
  'lic-unused': 'Ledig licenskapacitet',
};

// Decisions documented on Compliance (`cmp:<framework>`) and Konfiguration (`cfg:<area>`) carry a key of
// their own, so they are never mistaken for an Arbejdskø fund.
const CMP_LABEL = { cis18: 'CIS 18', iso: 'ISO 27001', nis2: 'NIS2', gdpr: 'GDPR' };
export const isCompliancePlaceNote = (note) => !!note?.findingKey && (note.findingKey.startsWith('cmp:') || note.findingKey.startsWith('cfg:'));

export function findingTitle(key) {
  if (!key) return null;
  if (key.startsWith('cmp:')) return `Compliance · ${CMP_LABEL[key.slice(4)] || key.slice(4)}`;
  if (key.startsWith('cfg:')) return `Konfiguration · ${AREA_TAB_LABEL[key.slice(4)] || key.slice(4)}`;
  if (FINDING_TITLES[key]) return FINDING_TITLES[key];
  // Device findings are keyed "enheder-<the reason>" — the reason is the title.
  if (key.startsWith('enheder-')) return key.slice('enheder-'.length);
  return null;
}

// Where the page a decision was documented on lives (Compliance / Konfiguration), or null for a fund.
export function noteSourcePath(tenantId, note) {
  const key = note?.findingKey || '';
  if (key.startsWith('cmp:')) return { path: `/tenant/${tenantId}/compliance`, label: 'Åbn i Compliance →' };
  if (key.startsWith('cfg:')) return { path: `/tenant/${tenantId}/configuration?area=${key.slice(4)}`, label: 'Åbn i Konfiguration →' };
  return null;
}

// Where "Åbn i Arbejdskø" should land: the area, the finding and the exact object.
export function workQueuePath(tenantId, area, note) {
  const p = new URLSearchParams({ area });
  if (note?.findingKey) p.set('finding', note.findingKey);
  if (note?.itemKey) p.set('item', note.itemKey);
  return `/tenant/${tenantId}/work-queue?${p.toString()}`;
}

// "19. sep. 2026 kl. 14.32"
export function fmtDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${d.toLocaleDateString('da-DK', { day: 'numeric', month: 'short', year: 'numeric' })} kl. ${d.toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' })}`;
}
